import {InjectionToken} from '@angular/core';
import {CommandId, IconSpec, PanelId} from '../../types';

export const WORKBENCH_VIEWCONTAINER_CONFIG = new InjectionToken<NormalViewContainerConfig>('WORKBENCH_VIEWCONTAINER_CONFIG');
export const WORKBENCH_SPLITVIEWCONTAINER_CONFIG = new InjectionToken<SplitViewContainerConfig>('WORKBENCH_SPLITVIEWCONTAINER_CONFIG');
export type ViewContainerId = string;

export interface SplitViewContainerConfig {
    type: 'SplitViewContainer';
    id: ViewContainerId;
    orientation: 'horizontal' | 'vertical';
}

export function isSplitViewContainerConfig(config: NormalViewContainerConfig | SplitViewContainerConfig): config is SplitViewContainerConfig {
    return config.type === 'SplitViewContainer';
}

export interface NormalViewContainerConfig {
    type: 'NormalViewContainer';
    id: ViewContainerId;
    name?: string;
    icon?: IconSpec;
    displayMode: 'tabbed' | 'stacked' | 'standalone';
    allowedPanels: PanelId[];
    defaultPanel?: PanelId;
    splitAllowed?: boolean; // default false
    moveAllowed?: boolean; // default true
    hideAllowed?: boolean; // default true
    popoutAllowed?: boolean; // default false
    toolbarCommandId?: CommandId;
    acceptsFileDrop?: boolean; // default false
}

export function isNormalViewContainerConfig(config: NormalViewContainerConfig | SplitViewContainerConfig): config is NormalViewContainerConfig {
    return config.type === 'NormalViewContainer';
}

export const CENTER_VIEW_CONTAINER_ID = 'general.center-viewcontainer';

export const CENTER_VIEW_CONTAINER_CONFIG: NormalViewContainerConfig = {
     type: 'NormalViewContainer',
     id: CENTER_VIEW_CONTAINER_ID,
     allowedPanels: ['center-center'],
     defaultPanel: 'center-center',
     splitAllowed: false,
     moveAllowed: false,
     hideAllowed: false,
     popoutAllowed: true,
     displayMode: 'tabbed', // in center view container, views are always displayed in tabs
     acceptsFileDrop: true,
}

